export default {
    ABOUT: "關於",
    ADVANCED_TOOLS: "交易者的高級工具",
    APPROVE: "批准",
    APY: "APY",
    AUDITS: "審核",
    BAL: "BAL：",
    BITCOIN_C: "比特幣",
    BITCOIN_S: "比特幣",
    BRAND_BLOG: "品牌博客",
    BURNED_TOKEN: "燃燒的令牌",
    BUY_FARM_SPEND: "購買，耕種，花費它並利用它！",
    BUY_ONE80_TOKENS: "購買Dopamine令牌",
    CANCEL: "取消",
    CIRCULATE_SUPPLY: "循環供應",
    CLOSE: "關",
    COMMUNITY: "社區",
    COMMUNITY_JOIN: "Dopamine正在改變Defi世界，我們的社區和開發商正在創建一個沒有寄宿生的財務世界，現在和未來。加入我們！",
    CONFIRM: "確認",
    CONFIRM_SWAP: "確認交換",
    CONNECT_WALLET: "連接錢包",
    CONNECT_WALLET_TRADE_TOKEN: "連接您的錢包，在幾秒鐘內用ETH交換任何令牌。",
    CONTRIBUTORS: "貢獻者",
    CRYPTO_GROW: "看著您的加密貨幣成長！",
    CUSTOMER_SUPPORT: "客戶支持",
    DEPOSIT_FEE: "存款費：",
    DETAILS: "細節",
    DEVELOPERS: "開發人員",
    DISCONNECT_WALLET: "斷開錢包",
    DOCUMENTATION: "文檔",
    EARNED: "贏得了",
    EARN_PASSIVE_INCOME: "用Dopamine賺取24/7的被動收入",
    EARN_WHILE_SLEEP: "睡覺時賺錢！",
    ETHEREUM: "以太坊",
    EXCHANGE: "交換",
    FARMS: "農場",
    FARMS_POOLS: "農場和游泳池",
    FINISHED: "完成的",
    GITHUB: "github",
    GUIDES: "嚮導",
    HARVEST: "收成",
    HEART_ECOSYSTEM: "Dopamine令牌是我們生態系統的核心。",
    HELP: "幫助",
    IDEAS_LAB: "創意實驗室",
    JOIN_ONE80: "加入Dopamine Defi Revolution。",
    LAUNCH_APP: "啟動應用程序",
    LIQUIDITY: "流動性",
    LIQUIDITY_PROVIDER_FEE: "流動性提供商費",
    LITE_PAPER: "Lite紙",
    LIVE: "居住",
    LOADING: "加載...",
    LOAD_MORE: "裝載更多",
    MARKET_CAP: "市值",
    MAX: "最大限度",
    MINIMUM_RECEIVED: "最低收到",
    MULTICHAIN_INSTANT_ACCESS: "多章即將推出，使您可以立即訪問一個加密世界。",
    NO_FARMS: "沒有農場",
    NO_POOLS: "沒有游泳池",
    ONE80: "Dopamine",
    ONE80_BENEFITS: "All，HODL，Exchange and Trade 24/7的Dopamine福利。",
    ONE80_EARNED: "賺Dopamine",
    ONE80_MAKES_EASY: "Dopamine使您的加密貨幣適合您很容易。",
    ONE80_WORLD: "Dopamine使我們的世界轉向環繞。",
    OUTPUT_ESTIMATED: "估計輸出。如果價格變化超過0.8％，您的交易將恢復。",
    OUTPUT_RECEIVE_ATLEAST: "估計輸出。您至少會收到",
    PARTHER_BURNED: "LP Parther/Busd燃燒",
    POOLS: "游泳池",
    PRICE: "價格",
    PRICE_IMPACT: "價格影響",
    READABLE_CONTENT: "漫長的事實是，讀者將因可讀內容而分心。",
    SEARCH_FARMS: "搜索農場",
    SEARCH_POOLS: "搜索池",
    SORT_BY: "排序方式",
    STAKE: "賭注：",
    STAKED_ONLY: "僅粘貼",
    STAKE_EARN_ONE80: "股份代幣賺取Dopamine",
    STAKE_ONE80: "Stake LP代幣賺取Dopamine",
    STAKE_TOKENS: "股份令牌",
    START_EARNING: "開始賺錢",
    SUCCESS_COMPLETE: "成功完成",
    SUSTAIN: "可持續性",
    TOKEN_PRICE: "令牌價格",
    TOTAL_LIQUIDITY: "總流動性：",
    TOTAL_STAKE: "總固定：",
    TOTAL_STAKED_S: "總固定",
    TOTAL_SUPPLY: "總供應",
    TRADERS_CHOOSE_ONE80: "交易者選擇Dopamine來自動將交易和路線交易與最佳DEX交換，從而為您帶來最佳效果。",
    TRADE_EARN_JOIN: "貿易，賺錢和加入我們的社區，從一一獎勵中受益。",
    TRADE_NOW: "現在交易",
    TRADE_REGISTRATION_HASSLE: "交易任何東西。沒有註冊，沒有麻煩",
    TRANSACTION_REVERT: "否則交易將恢復。",
    TROUBLE_SHOOT: "麻煩拍攝",
    TRUSTED_WORLD: "全世界信任的",
    UNLOCK_WALLET: "解鎖錢包",
    UNSTAKE_TOKENS: "刪除令牌",
    VIEW_ETHERSCAN: "查看bscscan",
    YOU_RECEIVE: "你會收到的",
    //Exchange and Liquidity
    ADD: "添加",
    ADD_LIQUIDITY: "增加流動性",
    AMOUNT: "數量",
    BALANCE: "平衡：",
    CLICK_SUPPLY_REVIEW: "一旦您滿意，請點擊供應供應供應。",
    CONNECT_WALLET_LIQUIDITY: "連接到錢包以查看您的流動性。",
    CREATE_PAIR: "創建對",
    CREATE_POOL: "創建池。",
    DONT_HAVE_LIQUIDITY: "您在這個池中還沒有流動性。",
    DONT_SEE_POOL_JOINED: "看不到您加入的游泳池嗎？",
    ENABLE: "使能夠",
    ENTER_AMOUNT: "輸入金額",
    ENTER_AMOUNT_S: "輸入金額",
    FIRST_LIQUIDITY_PROVIDER: "您是第一個流動性提供商。",
    FOR: "為了",
    FROM: "從",
    IMPORT_IT: "導入它。",
    IMPORT_POOL: "進口池",
    INSUFFICIENT: "不足的",
    INSUFFICIENT_BALANCE: "平衡不足",
    INSUFFICIENT_LIQUIDITY: "這項交易流動性不足。",
    LIQUIDITY_PROV_FEE: "流動性提供商費：",
    LIQUIDITY_REWARDS: "流動性提供商獎勵",
    LP_TOKENS_IN_WALLET: "LP代幣中的錢包",
    MINUTES: "分鐘",
    NO_LIQUTITY_LIST: "沒有液體清單",
    NO_POOL_FOUND: "找不到游泳池。",
    PER: "每",
    POOL: "水池",
    POOL_FOUND: "游泳池找到了！",
    POOL_SHARE: "您的游泳池分享：",
    POOL_TOKENS: "您的游泳池令牌：",
    PRICE_IMPACTS: "價格影響：",
    PRICE_IMPACT_HIGH: "價格影響高",
    RATES: "費率",
    RATIO_PRICE_POOL: "您添加的令牌比率將設定此池的價格。",
    RECENT_TRANSACTIONS: "最近的交易",
    REMOVE: "消除",
    REMOVE_LIQUIDITY: "刪除流動性",
    REMOVING_POOL_TOKENS: "刪除游泳池令牌將您的位置以當前的速率轉換為基礎令牌，與您在池的份額成正比。您收到的金額包括應計費。",
    ROUTE: "路線：",
    SELECT_A_TOKEN: "選擇一個令牌",
    SETTINGS: "設置",
    SHARE_OF_POOL: "分享池：",
    SLIPPAGE_TOL: "滑移公差",
    SLIPPAGE_TOLERANCE: "滑移耐受性：",
    SUPPLY: "供應",
    SWAP: "交換",
    TO: "至",
    TOKEN_FARM_UNSTAKE: "或者，如果您將Dopamine-LP令牌放在農場中，請取消種植它們在這裡看到它們。",
    TRANSACTION_DEADLINE: "交易截止日期",
    TRANSACTION_NOT_FOUND: "找不到Trancation",
    TRANSACTION_REVERT_PERCENTAGE: "如果價格不利於這個百分比",
    WITHDRAW_LIQUIDITY: "流動性提供商的所有交易與其在游泳池份額成正比的所有交易中獲得0.25%％的費用。費用被添加到游泳池中，實時積累，可以通過撤回流動性來要求。",
    YOUR_LIQUIDITY: "您的流動性",
    bALANCE: "平衡",
    MAXIMUM_SOLD: "最大銷售量",
    MINIMUM_RECEIVED_C: "最低接收",
    TOKEN_NAME: "令牌名稱",
    FOUND_MY_ADDRESS: "通過地址找到",
    IMPORT_TOKEN: "導入令牌",
    SEARCH_NAME: "按名稱或地址搜索",

    AND: "和",
    CONFIRM_SUPPLY: "確認供應",
    CONFIRM_TRANSACTION_WALLET: "在您的錢包中確認此交易",
    CONNECT_WALLETTT: "連接錢包",
    DEPOSITED: "沉積：",
    DISMISS: "解僱",
    ERROR: "錯誤",
    INPUT_ESTIMATED_SELL_MOST: "估計輸入。您最多會出售",
    LEARN_ABOUT_WALLETS: "了解有關錢包的更多信息",
    NEW_TO_ETHEREUM: "以太坊的新手？",
    OUTPUT_ESTIMATED_PRICE_CHANGES: "估計輸出。如果價格變化超過",
    PRICEE: "價格：",
    SUPPLYING: "供應",
    SWAPPING: "交換",
    TRANSACTION_REJECTED: "交易被拒絕",
    TRANSACTION_SUBMITTED: "交易提交",
    VIEW_ON_BSCSCAN: "在BSCSCAN上查看",
    WAITING_CONFIRMATION: "等待確認中",
    YOUR_TRANSACTION_REVERT: "您的交易將恢復。",
    YOU_WILL_RECEIVE: "您將收到 ：",
    PARTNERSHIPS: "夥伴關係",
}